<template>
  <div class="custom-modal" id="notification-dialog">
    <div class="modal-body no-footer">
      <el-tabs v-model="activeTab" @tab-click="tabChanged" stretch>
        <el-tab-pane :label="$t('notifications.menu.notifications')" name="first">
          <div class="notification-container">
            <div class="notication-actions">
              <el-button type="primary" size="mini" @click="readAllNotifications" :loading="loading == 'readAll'" round>{{ $t("notifications.events.mark_all") }}</el-button>
              <el-button type="primary" size="mini" round :loading="loading == 'deleteAll'" @click="deleteAllNotifications">{{ $t("notifications.events.delete_all") }}</el-button>
            </div>
            <div class="notification-item" v-for="(item, index) in notifications" :key="item.id + 'notification' + index" :class="{ isRead: item.isRead }">
              <div class="notification-related-img" :style="'background-image: url(' + $imageus + (getRelatedImage(item, 0) != null ? getRelatedImage(item, 0) : host + '/static/500x500-user.png') + '?width=150&height=150&mode=cover);'"></div>
              <div class="notification-detail">
                <div class="notification-title">{{ item.title }}</div>
                <div class="notification-content">
                  <span class="related-user" v-if="item.relatedUser != null && item.relatedUser.title != null">{{ item.relatedUser.title }}</span>
                  {{ item.details }}
                </div>
                <div class="notification-date">
                  {{ moment(item.createDate).fromNow() }}
                </div>
              </div>
              <div class="notification-event-img" v-if="item.relatedEvent != null">
                <img :src="$imageus + (getRelatedImage(item, 1) != null ? getRelatedImage(item, 1) : host + '/static/500x500-user.png') + '?width=150&height=150&mode=cover)'" alt="" />
              </div>
            </div>
          </div>
          <infinite-loading @infinite="loadNotificaitons" :identifier="notificationIdentifier">
            <div slot="no-more"></div>

            <NoData slot="no-results" v-if="notifications.length == 0" :title="$t('nodatakeys.notifications.nodatatitle')" :description="$t('nodatakeys.notifications.nodatadesc')" anim="holacon-notification-lottie" :loading="loading == 'notification'" :button="$t('nodatakeys.notifications.nodatabutton')" @btnClick="notificationReload" />
          </infinite-loading>
          <!-- <div class="notifications-container">
            <div class="container-inner" v-if="activeTab == 'first'">
              <div
                class="notification-item"
                v-for="item in notifications"
                :key="item.id"
                :class="item.isRead != true ? 'not-read' : ''"
              >
                <div class="notification-content">
                  <div
                    class="notification-image"
                    :style="
                      'background-image: url(' +
                        $imageus +
                        getRelatedImage(item) +
                        '?width=150&height=150&mode=cover);'
                    "
                  ></div>
                  <div class="notification-text">
                    <h5>{{ item.title }}</h5>
                    <p>{{ item.details }}</p>
                    <p>{{ moment(item.createDate).fromNow() }}</p>
                  </div>
                  <img
                    class="notification-related-image"
                    v-if="
                      item.relatedItem != null && item.relatedItem.image != null
                    "
                    :src="
                      $imageus +
                        item.relatedItem.image +
                        '?width=150&height=150&mode=cover'
                    "
                    alt=""
                  />
                </div>

                <div class="notification-menu">
                  <md-menu md-size="big" md-direction="bottom-end">
                    <md-button class="md-icon-button" md-menu-trigger>
                      <md-icon>more_vert</md-icon>
                    </md-button>

                    <md-menu-content>
                      <md-menu-item @click="deleteNotification(item)">
                        <span>{{ $t("notifications.events.delete") }}</span>
                        <md-icon>delete</md-icon>
                      </md-menu-item>

                      <md-menu-item @click="readNotification(item)">
                        <span>{{
                          $t("notifications.events.mark_as_read")
                        }}</span>
                        <md-icon>mark_unread_chat_alt</md-icon>
                      </md-menu-item>
                    </md-menu-content>
                  </md-menu>
                </div>
              </div>


            </div>
          </div> -->
        </el-tab-pane>
        <el-tab-pane :label="$t('appointment.appointments')" name="second">
          <div class="appointment-container">
            <div>
              <el-button size="mini" icon="el-icon-plus" @click="openMakeAppointmentDialog" :loading="loading == 'appointmentDialog'" round type="primary">{{ $t("appointment.title") }}</el-button>
            </div>

            <Nodata :title="$t('appointment.appointments')" :description="$t('contentNotFound')" anim="holacon-appointment-lottie" :loading="loading == 'appointments'" v-if="!getAppointmentList.coming.length > 0 && !getAppointmentList.pending.length > 0 && !getAppointmentList.past.length > 0" :button="$t('refresh')" @btnClick="refresh" />

            <template v-else>
              <div class="appointment-card">
                <div class="appointment-list-title">
                  <div class="icon-container">
                    <i class="fas fa-check-circle coming"></i>
                  </div>
                  <span>{{ $t("appointment.coming") }}</span>
                </div>
                <template v-if="getAppointmentList.coming.length > 0">
                  <div class="appointment-list-card" v-for="coming in getAppointmentList.coming" :key="coming.id">
                    <div class="appointment-list-card-title">
                      <span>{{ coming.title }}</span>
                      <el-dropdown trigger="click">
                        <span class="el-dropdown-link">
                          <i class="fas fa-ellipsis-v"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="openProfile(coming.ownerId)">{{ $t("view_profile") }}</el-dropdown-item>
                          <el-dropdown-item @click.native="rejectAppointment(coming.id)">{{ $t("appointment.reject") }}</el-dropdown-item>
                          <el-dropdown-item v-if="coming.ownerId == $store.state.user.id" @click.native="removeeAppointment(coming.id)">{{ $t("appointment.remove") }}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                    <div class="appointment-list-card-date">
                      <div class="date-icon">
                        <i class="fas fa-calendar"></i>
                      </div>
                      <span class="date-local">{{ moment(coming.appointmentDate).utc().format("DD MMM YYYY HH:mm") }}</span>
                      <i class="fas fa-long-arrow-alt-right"></i>
                      <span class="date-local">{{ getLocaleDate(coming.appointmentEndDate).format("HH:mm") }}</span>
                    </div>
                    <div class="appointment-list-card-date">
                      <div class="date-icon">
                        <i class="fas fa-map-marker-alt"></i>
                      </div>
                      <span>{{ coming.venue }}</span>
                    </div>
                    <div class="appointment-list-users-info">
                      <div class="list-users-title" @click="coming.isCollapse = !coming.isCollapse">
                        <div class="users-list-img">
                          <img v-for="user in coming.users.slice(0, 3)" :key="user.id" :src="user.image" width="24" height="24" />
                        </div>
                        <span>{{ $t("appointment.you_and_value", [coming.users.length - 1]) }}</span>
                        <i class="fas fa-chevron-down collapse-icon-btn" :class="{ active: coming.isCollapse }"></i>
                      </div>
                      <transition name="el-zoom-in-top" mode="out-in">
                        <div class="list-users-information" v-if="coming.isCollapse">
                          <hr />
                          <div class="user-item" v-for="userItem in coming.users" :key="userItem.id">
                            <img :src="userItem.image" :alt="userItem.fullName" />
                            <div class="user-item-title">
                              {{ userItem.fullName }}
                            </div>
                            <div
                              class="user-item-status coming"
                              :class="{
                                pending: userItem.status == 0,
                                coming: userItem.status == 1,
                                past: userItem.status == 2
                              }"
                            >
                              {{ userItem.status == 0 ? $t("appointment.pending_person") : userItem.status == 1 ? $t("appointment.join_person") : userItem.status == 2 ? $t("appointment.reject_person") : "" }}
                            </div>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                </template>
                <div class="alertbase info" v-else>
                  <i class="fas fa-info-circle"></i>
                  <span>{{ $t("appointment.no_coming") }}</span>
                </div>
              </div>
              <div class="appointment-card">
                <div class="appointment-list-title">
                  <div class="icon-container">
                    <i class="fas fa-times-circle pending"></i>
                  </div>
                  <span>{{ $t("appointment.pending") }}</span>
                </div>
                <template v-if="getAppointmentList.pending.length > 0">
                  <div class="appointment-list-card" v-for="pending in getAppointmentList.pending" :key="pending.id">
                    <div class="appointment-list-card-title">
                      <span>{{ pending.title }}</span>
                      <el-dropdown trigger="click">
                        <span class="el-dropdown-link">
                          <i class="fas fa-ellipsis-v"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item @click.native="openProfile(pending.ownerId)">{{ $t("view_profile") }}</el-dropdown-item>
                          <el-dropdown-item @click.native="approveAppointment(pending.id)" v-if="pending.users.find(x => x.id == $store.state.user.id).status == 0">{{ $t("appointment.approve") }}</el-dropdown-item>
                          <el-dropdown-item @click.native="rejectAppointment(pending.id)">{{ $t("appointment.reject") }}</el-dropdown-item>
                          <el-dropdown-item v-if="pending.ownerId == $store.state.user.id" @click.native="removeeAppointment(pending.id)">{{ $t("appointment.remove") }}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                    <div class="appointment-list-card-date">
                      <div class="date-icon">
                        <i class="fas fa-calendar"></i>
                      </div>
                      <span class="date-local">{{ getLocaleDate(pending.appointmentDate).format("DD MMM YYYY HH:mm") }}</span>
                      <i class="fas fa-long-arrow-alt-right"></i>
                      <span class="date-local">{{ getLocaleDate(pending.appointmentEndDate).format("HH:mm") }}</span>
                    </div>
                    <div class="appointment-list-card-date">
                      <div class="date-icon">
                        <i class="fas fa-map-marker-alt"></i>
                      </div>
                      <span>{{ pending.venue }}</span>
                    </div>
                    <div class="appointment-list-users-info">
                      <div class="list-users-title" @click="pending.isCollapse = !pending.isCollapse">
                        <div class="users-list-img">
                          <img v-for="user in pending.users.slice(0, 3)" :key="user.id" :src="user.image" width="24" height="24" />
                        </div>
                        <span>{{ $t("appointment.you_and_value", [pending.users.length - 1]) }}</span>
                        <i class="fas fa-chevron-down collapse-icon-btn" :class="{ active: pending.isCollapse }"></i>
                      </div>
                      <transition name="el-zoom-in-top" mode="out-in">
                        <div class="list-users-information" v-if="pending.isCollapse">
                          <hr />
                          <div class="user-item" v-for="userItem in pending.users" :key="userItem.id + '-pending-user'">
                            <img :src="userItem.image" :alt="userItem.fullName" />
                            <div class="user-item-title">
                              {{ userItem.fullName }}
                            </div>
                            <div
                              class="user-item-status coming"
                              :class="{
                                pending: userItem.status == 0,
                                coming: userItem.status == 1,
                                past: userItem.status == 2
                              }"
                            >
                              {{ userItem.status == 0 ? $t("appointment.pending_person") : userItem.status == 1 ? $t("appointment.join_person") : userItem.status == 2 ? $t("appointment.reject_person") : "" }}
                            </div>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                </template>
                <div class="alertbase info" v-else>
                  <i class="fas fa-info-circle"></i>
                  <span>{{ $t("appointment.no_pending") }}</span>
                </div>
              </div>
              <div class="appointment-card">
                <div class="appointment-list-title">
                  <div class="icon-container">
                    <i class="fas fa-clock past"></i>
                  </div>
                  <span>{{ $t("appointment.past") }}</span>
                </div>
                <template v-if="getAppointmentList.past.length > 0">
                  <div
                    class="appointment-list-card"
                    v-for="past in getAppointmentList.past"
                    :key="past.id"
                    :style="{
                      'background-color': past.users.find(x => x.id == $store.state.user.id).status == 2 ? '#FFD9D9' : ''
                    }"
                  >
                    <div class="appointment-list-card-title">
                      <span>{{ past.title }}</span>
                    </div>
                    <div class="appointment-list-card-date">
                      <div class="date-icon">
                        <i class="fas fa-calendar"></i>
                      </div>
                      <span class="date-local">{{ getLocaleDate(past.appointmentDate).format("DD MMM YYYY HH:mm") }}</span>
                      <i class="fas fa-long-arrow-alt-right"></i>
                      <span class="date-local">{{ getLocaleDate(past.appointmentEndDate).format("HH:mm") }}</span>
                    </div>
                    <div class="appointment-list-card-date">
                      <div class="date-icon">
                        <i class="fas fa-map-marker-alt"></i>
                      </div>
                      <span>{{ past.venue }}</span>
                    </div>
                    <div class="appointment-list-users-info">
                      <div class="list-users-title" @click="past.isCollapse = !past.isCollapse">
                        <div class="users-list-img">
                          <img v-for="user in past.users.slice(0, 3)" :key="user.id" :src="user.image" width="24" height="24" />
                        </div>
                        <span>{{ $t("appointment.you_and_value", [past.users.length - 1]) }}</span>
                        <i class="fas fa-chevron-down collapse-icon-btn" :class="{ active: past.isCollapse }"></i>
                      </div>
                      <transition name="el-zoom-in-top" mode="out-in">
                        <div class="list-users-information" v-if="past.isCollapse">
                          <hr />
                          <div class="user-item" v-for="userItem in past.users" :key="userItem.id">
                            <img :src="userItem.image" :alt="userItem.fullName" />
                            <div class="user-item-title">
                              {{ userItem.fullName }}
                            </div>
                            <div
                              class="user-item-status coming"
                              :class="{
                                pending: userItem.status == 0,
                                coming: userItem.status == 1,
                                past: userItem.status == 2
                              }"
                            >
                              {{ userItem.status == 0 ? $t("appointment.pending_person") : userItem.status == 1 ? $t("appointment.join_person") : userItem.status == 2 ? $t("appointment.reject_person") : "" }}
                            </div>
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                </template>
                <div class="alertbase info" v-else>
                  <i class="fas fa-info-circle"></i>
                  <span>{{ $t("appointment.no_past") }}</span>
                </div>
              </div>
            </template>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')">{{ $t("appointment.close_dialog") }}</el-button>
      </div>
      <div class="right-buttons"></div>
    </div> -->
    <!--
    <portal to="actions-buttons">
          <md-menu md-size="big" md-direction="bottom-end">
            <md-button class="md-icon-button" md-menu-trigger>
              <md-icon>more_vert</md-icon>
            </md-button>
            <md-menu-content>
              <md-menu-item @click="deleteAllNotifications()">
                <span>{{ $t("notifications.events.delete_all") }}</span>
                <md-icon>delete_forever</md-icon>
              </md-menu-item>

              <md-menu-item @click="readAllNotifications()">
                <span>{{ $t("notifications.events.mark_all") }}</span>
                <md-icon>mark_chat_read</md-icon>
              </md-menu-item>
            </md-menu-content>
          </md-menu>
    </portal>

    <div class="notifications-container">
      <md-tabs md-alignment="centered" md-dynamic-height @md-changed="tabChanged">

        <md-tab id="tab-1" :md-label="$t('notifications.menu.notifications')">

          <div class="container-inner" v-if="activeTab == 'tab-1'">
            <div
              class="notification-item"
              v-for="item in notifications"
              :key="item.id"
              :class="item.isRead != true ? 'not-read' : ''"
            >
              <div class="notification-content">
                <div
                  class="notification-image"
                  :style="
                    'background-image: url(' +
                      $imageus +
                      getRelatedImage(item) +
                      '?width=150&height=150&mode=cover);'
                  "
                ></div>
                <div class="notification-text">
                  <h5>{{ item.title }}</h5>
                  <p>{{ item.details }}</p>
                  <p>{{ moment(item.createDate).fromNow() }}</p>
                </div>
                <img
                  class="notification-related-image"
                  v-if="
                    item.relatedItem != null && item.relatedItem.image != null
                  "
                  :src="
                    $imageus +
                      item.relatedItem.image +
                      '?width=150&height=150&mode=cover'
                  "
                  alt=""
                />
              </div>

              <div class="notification-menu">
                <md-menu md-size="big" md-direction="bottom-end">
                  <md-button class="md-icon-button" md-menu-trigger>
                    <md-icon>more_vert</md-icon>
                  </md-button>

                  <md-menu-content>
                    <md-menu-item @click="deleteNotification(item)">
                      <span>{{ $t("notifications.events.delete") }}</span>
                      <md-icon>delete</md-icon>
                    </md-menu-item>

                    <md-menu-item @click="readNotification(item)">
                      <span>{{ $t("notifications.events.mark_as_read") }}</span>
                      <md-icon>mark_unread_chat_alt</md-icon>
                    </md-menu-item>
                  </md-menu-content>
                </md-menu>
              </div>
            </div>

            <infinite-loading
              @infinite="loadNotificaitons"
              v-if="activeTab == 'tab-1'"
            >
              <div slot="no-more"></div>

              <NoData slot="no-results"
                v-if="notifications.length == 0"
                :title="$t('nodatakeys.notifications.nodatatitle')"
                :description="$t('nodatakeys.notifications.nodatadesc')"
                anim="holacon-notification-lottie"
                :loading="loading"
                :button="$t('nodatakeys.notifications.nodatabutton')"
                @btnClick="loadNotificaitons();"
              />

            </infinite-loading>
          </div>
        </md-tab>

        <md-tab
          id="tab-2"
          :md-label="$t('notifications.menu.appointments')"
          md-disabled
        >
          <div class="container-inner" v-if="activeTab == 'tab-2'"></div>
        </md-tab>
      </md-tabs>
    </div> -->
  </div>
</template>

<script>
import InfiniteLoading from "vue-infinite-loading";
import moment from "moment/min/moment-with-locales";
import NoData from "@/modules/NoData";
import axios from "axios";

export default {
  name: "NotificationsDialog",

  components: {
    InfiniteLoading,
    NoData
  },

  data() {
    return {
      moment,
      activeTab: "first",
      loading: false,
      timeout: null,
      notifications: [],
      host: location.host == "localhost:3000" ? "https://live.holacon.com/" : "https://" + location.host,

      notificationIdentifier: +new Date(),
      error: {
        message: null,
        hasError: false
      }
    };
  },
  async created() {
    await this.$store.dispatch("getAppointmentList");
  },

  computed: {
    innerWidth() {
      return window.innerWidth;
    },
    getAppointmentList() {
      return this.$store.getters.getAppointmentList;
    }
  },
  watch: {
    activeTab() {
      this.notificationIdentifier += 1;
    }
  },

  methods: {
    notificationReload() {
      this.loading = "notification";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.notificationIdentifier += 1;
        this.loading = false;
      }, 500);
    },
    async refresh() {
      this.loading = "appointments";
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("getAppointmentList");
        this.loading = false;
      }, 500);
    },
    openProfile(id) {
      this.$root.$emit("getProfile", id);
    },
    // getLocaleDate(date){
    //   var offset = new Date(date).getTimezoneOffset();
    //   var newDate = this.moment(date).add(offset, 'minutes');
    //   return newDate;
    // },
    approveAppointment(id) {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("approveAppointment", id);
      }, 500);
    },
    rejectAppointment(id) {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("rejectAppointment", id);
      }, 500);
    },
    removeeAppointment(id) {
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("removeeAppointment", id);
      }, 500);
    },
    openMakeAppointmentDialog() {
      this.loading = "appointmentDialog";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$root.$emit("makeAppointmentDialog", null, null);
        this.loading = false;
      }, 500);
    },
    tabChanged(val) {
      if (val.name == undefined) {
        this.activeTab = null;
      } else if (val.name == "first") {
      } else {
        this.notifications = [];
        this.activeTab = val.name;
      }
    },

    readNotification(notification) {
      axios
        .post("notification/read", {
          id: notification.id
        })
        .then(res => {
          var index = this.notifications.findIndex(x => x.id == notification.id);
          if (index != -1) {
            this.notifications[index].isRead = true;
          }
        });
    },

    deleteNotification(notification) {
      axios
        .post("notification/delete", {
          id: notification.id
        })
        .then(res => {
          var index = this.notifications.findIndex(x => x.id == notification.id);
          if (index != -1) {
            this.notifications.splice(index, 1);
          }
        });
    },

    async readAllNotifications() {
      this.loading = "readAll";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await axios.post("notification/readall", {});
        if (!res.data.hasError) {
          for (var i = 0; i < this.notifications.length; i++) {
            this.notifications[i].isRead = true;
          }
          this.$store.state.unreadNotifications = 0;
        }
        this.loading = false;
      }, 500);
    },

    async deleteAllNotifications() {
      this.loading = "deleteAll";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await axios.post("notification/deleteall", {});
        if (res.data.hasError) {
          this.$message.error(res.data.message);
        } else {
          this.notifications = [];
          this.$store.state.unreadNotifications = 0;
          this.notificationIdentifier++;
        }
        this.loading = false;
      }, 500);
    },

    getRelatedImage(notification, type) {
      if (type == 0) {
        if (notification.relatedUser != null) {
          return notification.relatedUser.image;
        } else {
          return null;
        }
      }
      if (type == 1) {
        if (notification.relatedEvent != null) {
          return notification.relatedEvent.image;
        } else {
          return null;
        }
      }
    },

    loadNotificaitons($state) {
      axios
        .post("/notification/list", {
          skip: this.notifications.length,
          take: 10
        })
        .then(res => {
          this.notifications = [...this.notifications, ...res.data.data.items];
          if (res.data.data.items.length == 0) $state.complete();
          else $state.loaded();
        });
    }
  }
};
</script>

<style lang="less" scoped>
#notification-dialog {
  & > .modal-body {
    padding: 10px !important;
  }
  .appointment-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    .appointment-card {
      display: flex;
      flex-direction: column;
      gap: 8px;
      padding: 10px;
      border-radius: 8px;
      background: #ffffff;
      border: 0.5px solid #d6d9d9;
      border-radius: 8px;
      .appointment-list-title {
        display: flex;
        gap: 8px;
        align-items: center;
        font-size: 16px;
        font-weight: bold;
        .icon-container {
          padding: 3px;
          background-color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          i {
            font-size: 16px;
            &.coming {
              color: #268ea6;
            }
            &.pending {
              color: #f69656;
            }
            &.past {
              color: #8c929c;
            }
            padding: 2px;
            border: 1px solid #ccc;
            border-radius: 50%;
          }
        }
        span {
          font-weight: 500;
          font-size: 14px;
          color: #505763;
        }
      }
      .appointment-list-card {
        margin-top: 10px;
        border-radius: 8px;
        padding: 10px;
        flex-direction: column;
        display: flex;
        gap: 8px;
        background-color: #f6f6f6;
        .appointment-list-users-info {
          display: flex;
          flex-direction: column;
          gap: 8px;
          width: 100%;
          cursor: pointer;
          .list-users-information {
            display: flex;
            gap: 8px;
            flex-direction: column;
            .user-item {
              display: flex;
              flex-direction: row;
              align-items: center;
              gap: 12px;
              img {
                flex-shrink: 0;
                width: 50px;
                height: 50px;
                object-fit: cover;
                border-radius: 50%;
                border: 2px solid white;
              }
              .user-item-title {
                font-size: 16px;
                font-weight: bold;
                word-break: break-word;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                overflow: hidden;
              }
              .user-item-status {
                margin-left: auto;
                padding: 4px 10px;
                border-radius: 1rem;
                border: 2px solid white;
                color: white;
                font-weight: bold;
                flex-shrink: 0;
                @media screen and(max-width:768px) {
                  font-weight: 500;
                  font-size: 12px !important;
                }

                &.coming {
                  background-color: #268ea6;
                }
                &.pending {
                  background-color: #f69656;
                }
                &.past {
                  background-color: #8c929c;
                }
              }
            }
          }
          .list-users-title {
            display: flex;
            gap: 8px;
            align-items: center;
            span {
              font-weight: 500;
              font-size: 14px;
            }
            .collapse-icon-btn {
              margin-left: auto;
              cursor: pointer;
              transition: all 0.4s;

              &.active {
                transition: all 0.4s;
                transform: rotate(180deg);
              }
            }
            .users-list-img {
              display: flex;
              img {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                border: 2px solid white;
                margin-left: -15px;
                object-fit: cover;
                &:first-child {
                  margin-left: 0;
                }
              }
            }
          }
        }
        .appointment-list-card-date {
          display: flex;
          align-items: center;

          gap: 8px;
          .date-local {
            font-weight: 600;
            font-size: 14px;
          }
          .date-icon {
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: white;
            border-radius: 8px;
            padding: 6px;
            i {
              color: #268ea6;
              font-size: 12px !important;
            }
          }
        }
        .appointment-list-card-title {
          display: flex;
          width: 100%;
          justify-content: space-between;
          align-items: center;
          span {
            font-weight: bold;
            font-size: 16px;
          }
          .el-dropdown {
            width: 20px;
            height: 20px;
            padding: 6px;
            cursor: pointer;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            &:hover {
              background-color: white;
            }
          }
        }
      }
    }
  }
  .notification-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    .notification-item {
      padding: 10px;
      background-color: #fff;
      box-shadow: 0px 2px 10px rgba(41, 47, 59, 0.1);
      border-radius: 8px;
      display: flex;
      align-items: center;
      gap: 10px;
      &.isRead {
        background: #e8ebef;
        box-shadow: unset;
      }
      .notification-detail {
        .notification-title {
          font-weight: bold;
          word-break: break-word;
          font-size: 12px;
        }
        .notification-content {
          font-weight: 500;
          word-break: break-word;
          .related-user {
            text-decoration: underline;
            color: #268ea6;
            font-weight: 600;
          }
        }
        .notification-date {
          font-weight: bold;
          font-size: 12px;
        }
      }

      .notification-related-img {
        flex-shrink: 0;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        border: 2px solid #e8ebef;
        background-size: cover;
        background-position: center;
      }
      .notification-event-img {
        flex-shrink: 0;
        width: 60px;
        height: 60px;
        border-radius: 1rem;
        padding: 10px;
        background-color: #fff;
      }
    }
  }
}
// .notifications-container {
//   flex: 1 0 100%;
//   padding: 16px;
//   width: 100%;
//   overflow-y: scroll;
//   max-height: calc(~"100vh - 160px");

//   .container-inner {
//     .notification-item {
//       display: flex;
//       flex-direction: row;
//       justify-content: space-between;
//       align-items: center;
//       width: 100%;
//       padding: 12px 0px;
//       border-bottom: 1px solid #f1f3f6;

//       &:last-child {
//         border-bottom: none !important;
//       }

//       &.not-read {
//         background-color: #f1f3f6;
//       }

//       .notification-content {
//         display: flex;
//         flex-direction: row;
//         justify-content: flex-start;
//         align-items: center;
//         width: 100%;

//         .notification-image {
//           width: 50px;
//           height: 50px;
//           border-radius: 50%;
//           background-size: cover;
//           background-position: center;
//           background-repeat: no-repeat;
//           display: inline-block;
//           border: 3px solid #f1f1f1;
//           position: absolute;
//         }

//         .notification-text {
//           padding-right: 8px;
//           margin-left: 58px;
//           width: 100%;

//           h5 {
//             margin: 0px;
//             color: #292f3b;
//             font-size: 14px;
//           }

//           p {
//             margin: 0px;
//             color: #8c929c;
//             font-size: 13px;
//           }
//         }

//         .notification-related-image {
//           width: 50px;
//           height: auto;
//           border-radius: 8px;
//         }
//       }
//     }
//   }
// }
// #notifications-dialog {
//   width: 100%;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   flex-direction: column;
//   padding-top: 0;

//   .md-tabs-navigation {
//     border-bottom: 1px solid #f1f3f6;
//   }

//   .md-button-content {
//     font-size: 16px;
//   }

// }

// .custom-notification-dialog {
//   .md-dialog-container {
//     max-height: calc(~"100vh - 100px") !important;
//     min-width: 520px;

//     .md-tab {
//       padding: 0px !important;
//     }
//   }
// }

// @media (max-width: 768px) {
//   #notifications-dialog {
//     .notifications-container {
//       overflow-y: scroll;
//       max-height: calc(~"100vh - 90px");
//       padding: 0px;
//     }
//   }

//   .custom-notification-dialog {
//     .md-dialog-container .md-tab {
//       padding: 0px;
//     }

//     .md-dialog-container {
//       max-height: 100% !important;
//       max-width: 100% !important;
//       min-width: 100% !important;
//       border-radius: 0px !important;
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/components/NotificationsDialog.vue